import { v4 as uuidv4 } from 'uuid';

export const CSAS_DTO_SESSION_CLIENT = {
  cluid: uuidv4(),
  forename: 'Tx',
  surname: 'Runner',
  middleName: '',
  degree: '',
  additionalDegree: '',
  email: 'tx.runner@example.com',
};
